import { ObjectSchema } from 'yup';
import { AnySchema, BuiltInValidation } from '../../../../types';
import { InternationalPhoneNumber } from './InternationalPhoneNumber';
import { CountryCallingCode, CountryCode, InternationalPhoneNumberModel } from './phoneNumberTypes';

export const RESTRICTED_COUNTRY_CODE_MESSAGE = 'Phone number must have one of the allowed country codes: ';

export const phoneNumberBuiltInValidation: BuiltInValidation = (schema, userValidation, errorMessages) => {
  const allowed = userValidation?.allowedCountryCodes ?? [];
  const allowedCallingCodes = [
    ...new Set(allowed.map((iso) => InternationalPhoneNumber.getCallingCode(iso as CountryCode)))
  ];
  const restrictMessage = `${RESTRICTED_COUNTRY_CODE_MESSAGE}${allowedCallingCodes
    .map((code) => `+${code}`)
    .sort()
    .join(', ')}`;

  return (schema as ObjectSchema<object | undefined | null>)
    .test('phone-number', errorMessages?.value?.[0] ?? 'Invalid phone number', (value) =>
      new InternationalPhoneNumber(value as InternationalPhoneNumberModel).isValidModel()
    )
    .test('restrict-country-code', restrictMessage, (value) => {
      if (!allowedCallingCodes.length) return true;

      const model = value as InternationalPhoneNumberModel | undefined;
      if (!model?.number) return true;

      return allowedCallingCodes.includes(model.countryCode as CountryCallingCode);
    }) as AnySchema;
};
